import googleTagManager from "react-gtm-module";

import { isProductionEnv } from "src/utils";

const { REACT_APP_GOOGLE_TAG_MANAGER_ID = "" } = process.env;

if (isProductionEnv())
  googleTagManager.initialize({ gtmId: REACT_APP_GOOGLE_TAG_MANAGER_ID });
